import { AttributeValue } from "./AttributeValue";
import { AttributeView } from "./AttributeView";
import { ExportValue } from "./ExportValue";
import { Feature } from "ol";
import { FeatureType } from "@/geoMap/define/FeatureType";
import { IAttributeConvert } from "./IAttributeConvert";

/**
 * 画面幅
 */
const VALUE_WIDTH = 400;

/**
 * 画面サイズ（縦幅）
 */
const VALUE_HEIGHT = 495;

/**
 * 出力JSONファイル名
 */
const VALUE_JSON_FILE_NAME = "rkil_dist_yyyyMMdd_HHmmss.geojson";

/**
 * 出力CSVファイル名
 */
const VALUE_CSV_FILE_NAME = "rkil_dist_yyyyMMdd_HHmmss.csv";

/**
 * ロードキル発生状況属性変換用クラス
 */
export class RoadkillOccurrencesStatusAttributeConvert
  implements IAttributeConvert
{
  /**
   * 地物
   */
  feature: Feature;

  /**
   * 属性画面タイトル
   */
  title: string;

  constructor(feature: Feature) {
    this.feature = feature;
    this.title = `ロードキル（ロードキル発生状況）`;
  }

  /**
   * 地物タイプ取得
   */
  getFeatureType(): FeatureType {
    return FeatureType.RoadkillOccurrences;
  }

  /**
   * 画面用フォーマット取得
   */
  getViewFormatData(): AttributeView {
    const properties = this.feature.getProperties();

    // 画面項目定義リスト
    const items = [
      {
        key: "ID",
        value: properties.ID,
        isSimple: true,
      },
      {
        key: "都道府県",
        value: properties.都道府県,
        isSimple: true,
      },
      {
        key: "発見場所（市区町村）",
        value: properties.市町村,
        isSimple: true,
      },
      {
        key: "道路種別",
        value: properties.道路種別,
        isSimple: true,
      },
      {
        key: "路線番号",
        value: properties.路線番号,
        isSimple: true,
      },
      {
        key: "kp",
        value: properties.KP,
        isSimple: true,
      },
      {
        key: "上下別",
        value: properties.上下別,
        isSimple: true,
      },
      {
        key: "発見日時",
        value:
          properties.発見_年 &&
          properties.発見_月 &&
          properties.発見_日 &&
          properties.発見_時間
            ? `${properties.発見_年}/${properties.発見_月}/${properties.発見_日} ${properties.発見_時間}`
            : "-",
        isSimple: true,
      },
      {
        key: "昼夜",
        value: properties.昼夜,
        isSimple: true,
      },
      {
        key: "天候",
        value: properties.天候,
        isSimple: true,
      },
      {
        key: "動物種",
        value: properties.動物種,
        isSimple: true,
      },
      {
        key: "交通調査基本区間番号",
        value: properties.センサス交通調査区間番号,
        isSimple: true,
      },
      {
        key: "道路管理者（地方整備局）",
        value: properties.地方整備局,
        isSimple: false,
      },
      {
        key: "道路管理者（事務所等）",
        value: properties.事務所等,
        isSimple: false,
      },
      {
        key: "道路管理者（出張所等）",
        value: properties.出張所等,
        isSimple: false,
      },
      {
        key: "発見場所（緯度）",
        value: properties["発見場所（緯度）"],
        isSimple: false,
      },
      {
        key: "発見場所（経度）",
        value: properties["発見場所（経度）"],
        isSimple: false,
      },
    ];
    // 画面項目リストでAttributeValue配列を生成しクラス変数に格納後、return
    const attributeValues: AttributeValue[] = [];
    items.forEach((item) => {
      attributeValues.push(
        new AttributeValue(
          item.key,
          item.value ? item.value.toString() : null,
          item.isSimple
        )
      );
    });
    const attributeView = new AttributeView(
      attributeValues,
      this.title,
      VALUE_WIDTH,
      VALUE_HEIGHT,
      VALUE_HEIGHT,
      null,
      false,
      false
    );
    return attributeView;
  }

  /**
   * ファイル出力用項目取得
   */
  getExportValue(): ExportValue {
    const feature = this.feature.clone();
    feature.getGeometry().transform("EPSG:3857", "EPSG:4326");
    const attributeValues = this.getViewFormatData().attributeValues;
    return new ExportValue(
      feature,
      attributeValues,
      VALUE_JSON_FILE_NAME,
      VALUE_CSV_FILE_NAME
    );
  }
}
